export const MICROSOFT_CONNECT_METHODS = {
    MANAGED: {
        title: "Sign in with Microsoft",
        description: "A Microsoft admin approves Origin's app. There is nothing to create or rotate.",
        recommended: true,
    },
    BRING_YOUR_OWN: {
        title: "Use your own app registration",
        description: "You register an app in Entra, grant its permissions, and rotate its client secret.",
    },
};
